import { useState } from 'react';

export const Text = (props) => {
    const { name, value } = props;
    const [newVal, setNewVal] = useState(value);
    return (
        <div className="row">
            <label className="label" htmlFor={name}>{name}</label>
            <input type="text" id={name} name={name} value={newVal} onChange={(e) => { setNewVal(e.target.value); }} />
        </div>
    )
}